import React from 'react'
import map from 'lodash/map'

import {
  IFollowedExportation,
} from '@EditorModules/Exportation/types'

import './ExportationsProgress.scss'
import ExportationProgress from './ExportationProgress'

interface ExportationsProgressProps {
  readonly userName?: string
  readonly exportations: IFollowedExportation[]
}

const ExportationsProgress: React.FC<ExportationsProgressProps> = props => {
  const {
    userName,
    exportations,
  } = props

  const renderExportationsProgress = map(exportations, (exportation: IFollowedExportation) => {
    const { id } = exportation

    return (
      <ExportationProgress
        key={id}
        userName={userName}
        exportation={exportation}
      />
    )
  })

  return (
    <div
      className="ExportationsProgress"
    >
      {renderExportationsProgress}
    </div>
  )
}

export default ExportationsProgress
